import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PeekService {
    templateRef: TemplateRef<any>;
    public open$: Observable<boolean>;
    private openSubject: Subject<boolean>;

    public noScroll$: Observable<boolean>;
    private noScrollSubject: Subject<boolean>;

    public resetScrollToTop$: Observable<boolean>;
    private resetScrollToTopSubject: Subject<boolean>;

    public showScrollBar$: Observable<boolean>;
    private showScrollBarSubject: Subject<boolean>;

    constructor() {
        this.openSubject = new Subject<boolean>();
        this.open$ = this.openSubject.asObservable();

        this.noScrollSubject = new Subject<boolean>();
        this.noScroll$ = this.noScrollSubject.asObservable();

        this.resetScrollToTopSubject = new Subject<boolean>();
        this.resetScrollToTop$ = this.resetScrollToTopSubject.asObservable();

        this.showScrollBarSubject = new Subject<boolean>();
        this.showScrollBar$ = this.showScrollBarSubject.asObservable();
    }

    setOpen(value: boolean) {
        this.openSubject.next(value);
    }

    setNoScroll(value: boolean) {
        this.noScrollSubject.next(value);
    }

    setResetScrollToTop(value: boolean) {
        this.resetScrollToTopSubject.next(value);
    }

    setShowScrollBar(value: boolean) {
        this.showScrollBarSubject.next(value);
    }
}
